(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5Qy4z", function(module, exports) {
$parcel$export(module.exports, "PasswordResetPage", function () { return (parcelRequire("fxD4G")).PasswordResetPage; });
parcelRequire("fxD4G");

});
parcelRegister("fxD4G", function(module, exports) {

$parcel$export(module.exports, "PasswordResetPage", function () { return $9f000063304e2eee$export$5bbd98196cb66ba8; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");

var $angn7 = parcelRequire("angn7");

var $cseD4 = parcelRequire("cseD4");

var $fzqPg = parcelRequire("fzqPg");

var $2fIUB = parcelRequire("2fIUB");

var $eQidV = parcelRequire("eQidV");

var $gCykg = parcelRequire("gCykg");

var $3owfH = parcelRequire("3owfH");

var $4DfoO = parcelRequire("4DfoO");
parcelRequire("2RQ8A");
var $aaRQJ = parcelRequire("aaRQJ");

var $bD3O1 = parcelRequire("bD3O1");

var $1IbJL = parcelRequire("1IbJL");
const $9f000063304e2eee$var$SFormWrapper = (0, $avNx5.default)((0, $gCykg.SContentWrapper))`
    width: 100%;
    max-width: 435px;
`;
function $9f000063304e2eee$export$5bbd98196cb66ba8({ className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    const { value: value, apply: apply } = (0, $2fIUB.default)({
        password: "",
        passwordCompare: ""
    });
    const [error, setError] = (0, $jGnJo.useState)("");
    const [submitError, setSubmitError] = (0, $jGnJo.useState)(false);
    const [showPassword, toggleShowPassword] = (0, $jGnJo.useState)(false);
    const [showPasswordCompare, toggleShowPasswordCompare] = (0, $jGnJo.useState)(false);
    const navigate = (0, $gCMx8.useNavigate)();
    const [searchParams] = (0, $gCMx8.useSearchParams)();
    const { execute: resetPassword, status: status } = (0, $cseD4.default)((token, value)=>(0, $4DfoO.default)(token, value).then(()=>{
            (0, $bD3O1.default).setItem("notification", {
                text: "msgPasswordReset"
            });
            navigate("/login", {
                replace: true
            });
        }).catch(()=>setSubmitError(true)));
    const handleSubmit = (0, $jGnJo.useCallback)((event)=>{
        event.preventDefault();
        const token = searchParams?.get("token");
        if (!token) return;
        if (value.password !== value.passwordCompare) {
            setError(text("msgPasswordDoNotMatch"));
            return;
        }
        if (!(0, $angn7.isPasswordLongEnough)(value.password)) {
            setError(text("msgPasswordToShortSignup"));
            return;
        }
        resetPassword(token, value);
    }, [
        value,
        searchParams
    ]);
    const changeValue = (value)=>{
        setError("");
        apply(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        background: "#ffffff",
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($9f000063304e2eee$var$SFormWrapper, null, submitError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SNotification), {
        "data-testid": "signInError",
        error: submitError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgPasswordNotChanged"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eQidV.FormHeader), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "passwordForm",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3owfH.PasswordInput), {
        label: value.password.length > 0 ? text("lblPassword") : "",
        placeholder: text("lblPassword"),
        onChange: (value)=>changeValue({
                password: value
            }),
        showPassword: showPassword,
        message: !value.password ? text("msgMinimumPasswordLength") : null,
        error: error,
        errorTestId: "passwordInputError",
        toggleShowPasswordFlag: toggleShowPassword,
        hasText: value.password.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $3owfH.PasswordInput), {
        label: value.passwordCompare.length > 0 ? text("lblConfirmPasswordField") : "",
        placeholder: text("lblConfirmPasswordField"),
        onChange: (value)=>changeValue({
                passwordCompare: value
            }),
        showPassword: showPasswordCompare,
        toggleShowPasswordFlag: toggleShowPasswordCompare,
        hasText: value.passwordCompare.length > 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $aaRQJ.SubmitButton), {
        disabled: !value.password || !value.passwordCompare || status === (0, $cseD4.Status).PENDING
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "btnResetPassword"
    }))))));
}

});
parcelRegister("angn7", function(module, exports) {

$parcel$export(module.exports, "MIN_PASSWORD_LENGTH", function () { return $63e849c54beb0674$export$6f63e37550343081; });
$parcel$export(module.exports, "MAX_FIRST_NAME_LENGTH", function () { return $63e849c54beb0674$export$8d95a259802f436c; });
$parcel$export(module.exports, "MAX_LAST_NAME_LENGTH", function () { return $63e849c54beb0674$export$a1ce64b0aabb67a7; });
$parcel$export(module.exports, "MAX_USER_EMAIL_LENGTH", function () { return $63e849c54beb0674$export$e457d43a6d8db9d4; });
$parcel$export(module.exports, "MAX_MOBILE_LENGTH", function () { return $63e849c54beb0674$export$b5adbff18555fae2; });
$parcel$export(module.exports, "isPasswordLongEnough", function () { return $63e849c54beb0674$export$ff7e0dbee5b5a1ba; });
const $63e849c54beb0674$export$6f63e37550343081 = 8;
const $63e849c54beb0674$export$8d95a259802f436c = 50;
const $63e849c54beb0674$export$a1ce64b0aabb67a7 = 50;
const $63e849c54beb0674$export$e457d43a6d8db9d4 = 50;
const $63e849c54beb0674$export$b5adbff18555fae2 = 50;
const $63e849c54beb0674$export$ff7e0dbee5b5a1ba = (password)=>password.length >= $63e849c54beb0674$export$6f63e37550343081;

});

parcelRegister("2fIUB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52ba2c507008a5b9$export$2e2bcd8739ae039; });

var $jGnJo = parcelRequire("jGnJo");
const $52ba2c507008a5b9$var$isNaNType = (value)=>typeof value === "number" && isNaN(value);
const $52ba2c507008a5b9$var$isSame = (valueA, valueB)=>{
    if (typeof valueA !== typeof valueB) return false;
    if ($52ba2c507008a5b9$var$isNaNType(valueA) && $52ba2c507008a5b9$var$isNaNType(valueB)) return true;
    if (valueA === valueB) return true;
    if (typeof valueA !== "object") return false;
    if (valueA === null || valueB === null) return false;
    if (Array.isArray(valueA)) {
        if (!Array.isArray(valueB)) return false;
        if (valueA.length !== valueB.length) return false;
        return valueA.every((v, index)=>$52ba2c507008a5b9$var$isSame(v, valueB[index]));
    }
    const keysA = Object.keys(valueA);
    const keysB = Object.keys(valueB);
    if (keysA.length !== keysB.length) return false;
    if (keysA.some((key)=>!keysB.includes(key))) return false;
    return keysA.every((key)=>$52ba2c507008a5b9$var$isSame(valueA[key], valueB[key]));
};
const $52ba2c507008a5b9$var$selectDifferentProperties = (origin, patch)=>{
    return Object.keys(patch).reduce((diff, key)=>{
        return origin && key in origin && $52ba2c507008a5b9$var$isSame(patch[key], origin[key]) ? diff : Object.assign(diff, {
            [key]: patch[key]
        });
    }, {});
};
function $52ba2c507008a5b9$export$2e2bcd8739ae039(origin, patch) {
    const [diff, setDiff] = (0, $jGnJo.useState)({});
    return (0, $jGnJo.useMemo)(()=>({
            diff: diff,
            value: {
                ...origin,
                ...diff
            },
            apply: (changes)=>{
                const newDiff = patch ? patch(changes, diff, origin) : $52ba2c507008a5b9$var$selectDifferentProperties(origin, {
                    ...diff,
                    ...changes
                });
                setDiff(newDiff);
            },
            set: (changes)=>{
                const newDiff = patch ? patch(changes, {}, origin) : $52ba2c507008a5b9$var$selectDifferentProperties(origin, changes);
                setDiff(newDiff);
            },
            reset: ()=>setDiff({}),
            hasChanges: Boolean(Object.keys(diff).length)
        }), [
        origin,
        diff,
        setDiff
    ]);
}

});

parcelRegister("4DfoO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $badb3e0745f62a46$export$2e2bcd8739ae039; });

var $4WTDi = parcelRequire("4WTDi");
const $badb3e0745f62a46$var$resetUserPassword = (token, data)=>(0, $4WTDi.default)({
        method: "PUT",
        path: `/auth/password/reset/${token}`,
        body: data
    });
var $badb3e0745f62a46$export$2e2bcd8739ae039 = $badb3e0745f62a46$var$resetUserPassword;

});

parcelRegister("2RQ8A", function(module, exports) {
$parcel$export(module.exports, "SubmitButton", function () { return (parcelRequire("aaRQJ")).SubmitButton; });
parcelRequire("aaRQJ");

});
parcelRegister("aaRQJ", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", function () { return $59ce620a1fe1e332$export$8b7b7cdfb85d78c5; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $97cl7 = parcelRequire("97cl7");

var $b6qTG = parcelRequire("b6qTG");

var $5wk6V = parcelRequire("5wk6V");
const $59ce620a1fe1e332$export$e97afde9f5f901c8 = (0, $avNx5.default).button`
    display: flex;
    min-width: 150px;
    margin: 0 auto;
    padding: 9px 46px;
    border-radius: 16px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border: none;
    transition: 0.2s ease;
    font-size: 15px;
    svg {
        path {
            fill: ${({ theme: theme })=>theme.font.successColor};
        }
    }

    &[disabled],
    &[disabled]:active:not(:hover) {
        background-color: #e6e6e6;
        color: ${({ theme: theme })=>theme.font.lightestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &.inverted {
        background-color: #fff;
        color: #000;
    }

    &:hover {
        background-color: ${({ theme: theme })=>theme.font.successColor};
        color: #000;

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }
    &:active,
    &:active:not(:hover) {
        background-color: #d9edd9;
        color: ${({ theme: theme })=>theme.font.darkestColor};

        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
    }

    &[disabled]:hover {
        svg {
            path {
                fill: ${({ theme: theme })=>theme.font.lightestColor};
            }
        }
        color: ${({ theme: theme })=>theme.font.lightestColor};
        background-color: #e6e6e6;
    }
`;
function $59ce620a1fe1e332$export$8b7b7cdfb85d78c5({ children: children, className: className, style: style, inverted: inverted, disabled: disabled, loading: loading = false }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($59ce620a1fe1e332$export$e97afde9f5f901c8, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className, {
            inverted: inverted
        }),
        style: style,
        "data-testid": "submitButton",
        type: "submit",
        disabled: disabled
    }, children, " ", !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $5wk6V.SignInArrowIcon), {
        className: "ml-2"
    }), loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $97cl7.FontAwesomeIcon), {
        icon: (0, $b6qTG.faSpinner),
        pulse: true,
        "data-testid": "spinner"
    }));
}

});




parcelRegister("f3Zjn", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return (parcelRequire("3ps0j")).ResetPasswordRequestPage; });
parcelRequire("3ps0j");

});
parcelRegister("3ps0j", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestPage", function () { return $4ddbd2349393dbcd$export$d071176b85126a1a; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");

var $fzqPg = parcelRequire("fzqPg");

var $gCykg = parcelRequire("gCykg");

var $2GMY2 = parcelRequire("2GMY2");

var $a3EFh = parcelRequire("a3EFh");

var $ecLB8 = parcelRequire("ecLB8");

var $gIveR = parcelRequire("gIveR");

var $eQidV = parcelRequire("eQidV");
parcelRequire("2RQ8A");
var $aaRQJ = parcelRequire("aaRQJ");

var $3aX9D = parcelRequire("3aX9D");

var $1IbJL = parcelRequire("1IbJL");
const $4ddbd2349393dbcd$var$SFormWrapper = (0, $avNx5.default)((0, $gCykg.SContentWrapper))`
    max-width: 510px;
    padding: 0 10px;
`;
const $4ddbd2349393dbcd$var$SLink = (0, $avNx5.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        text-align: center;
        width: 100%;
        display: inline-block;
        padding-top: 30px;
    }
`;
const $4ddbd2349393dbcd$var$SInstruction = (0, $avNx5.default).div`
    line-height: 1.5em;
    padding-bottom: 37px;
    text-align: center;
`;
const $4ddbd2349393dbcd$var$SHeaderWrapper = (0, $avNx5.default).div`
    padding-bottom: 45px;
`;
function $4ddbd2349393dbcd$export$d071176b85126a1a({ className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    const [email, setEmail] = (0, $jGnJo.useState)("");
    const [errorMessage, setErrorMessage] = (0, $jGnJo.useState)("");
    const navigate = (0, $gCMx8.useNavigate)();
    const [requestPasswordReset, { isLoading: isLoading }] = (0, $2GMY2.useAuthRequestPasswordResetMutation)();
    const handleSubmit = (0, $jGnJo.useCallback)((event)=>{
        event.preventDefault();
        if (!(0, $ecLB8.validateEmailFormat)(email)) {
            setErrorMessage(text("msgEmailFormatIncorrect"));
            return;
        }
        requestPasswordReset({
            userCredentials: {
                email: email
            }
        }).unwrap().then(()=>{
            navigate("/reset-password-request-success", {
                replace: true
            });
        }).catch((error)=>{
            if ((0, $a3EFh.getErrorMessageCode)(error) === "msgEmailDoesntExist") {
                setErrorMessage(text("msgEmailDoesntExist", {
                    company: "ChargeAmps"
                }));
                return;
            }
            navigate("/reset-password-request-error", {
                replace: true
            });
        });
    }, [
        email,
        navigate,
        requestPasswordReset,
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        background: (0, $3aX9D.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($4ddbd2349393dbcd$var$SFormWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($4ddbd2349393dbcd$var$SHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eQidV.FormHeader), {
        "data-testid": "header"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($4ddbd2349393dbcd$var$SInstruction, {
        "data-testid": "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgChargeAmpsResetPasswordInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("form", {
        onSubmit: handleSubmit,
        "data-testid": "form",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.SSpacer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.InputGroup), {
        errorTestId: "errorMsg",
        errorMsg: errorMessage,
        inverted: false,
        label: email && text("lblEmail")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gIveR.SInput), {
        placeholder: text("lblEmail"),
        onInput: (event)=>{
            const value = event.target.value;
            setErrorMessage("");
            setEmail(value);
        },
        value: email,
        "data-testid": "emailInput"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $aaRQJ.SubmitButton), {
        disabled: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "btnResetPassword"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($4ddbd2349393dbcd$var$SLink, {
        as: (0, $gCMx8.Link),
        to: "/login",
        "data-testid": "returnBtn"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "btnReturnToSignIn"
    }))));
}

});


parcelRegister("8JDp9", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return (parcelRequire("iSbEb")).ResetPasswordRequestSuccessPage; });
parcelRequire("iSbEb");

});
parcelRegister("iSbEb", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestSuccessPage", function () { return $5144b83da89d9667$export$4588528796d14202; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $gCMx8 = parcelRequire("gCMx8");
parcelRequire("b2a4Y");
var $dlHVP = parcelRequire("dlHVP");

var $gCykg = parcelRequire("gCykg");

var $fzqPg = parcelRequire("fzqPg");

var $3aX9D = parcelRequire("3aX9D");

var $1IbJL = parcelRequire("1IbJL");
function $5144b83da89d9667$export$4588528796d14202({ className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        background: (0, $3aX9D.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $dlHVP.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>{
            navigate("/login", {
                replace: true
            });
        },
        type: (0, $dlHVP.LandingMessageType).SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("div", {
        "data-testid": "message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "msgResetPasswordLinkSent"
    }))));
}

});
parcelRegister("b2a4Y", function(module, exports) {
$parcel$export(module.exports, "LandingMessage", function () { return (parcelRequire("dlHVP")).LandingMessage; });
$parcel$export(module.exports, "LandingMessageType", function () { return (parcelRequire("dlHVP")).LandingMessageType; });
parcelRequire("dlHVP");

});
parcelRegister("dlHVP", function(module, exports) {

$parcel$export(module.exports, "LandingMessageType", function () { return $3b5c46f6593f9a38$export$ead8dc60ae5441ac; });
$parcel$export(module.exports, "LandingMessage", function () { return $3b5c46f6593f9a38$export$d88a99e06d24b3e0; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");
parcelRequire("3skFI");
var $45iue = parcelRequire("45iue");
parcelRequire("gqF3g");
var $4og9Q = parcelRequire("4og9Q");

var $6Bp5U = parcelRequire("6Bp5U");

var $3aX9D = parcelRequire("3aX9D");

var $eQidV = parcelRequire("eQidV");
const $3b5c46f6593f9a38$var$SWrapper = (0, $avNx5.default).div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;
const $3b5c46f6593f9a38$var$SIcon = (0, $avNx5.default).div`
    padding-bottom: 30px;
`;
const $3b5c46f6593f9a38$var$SBody = (0, $avNx5.default).div`
    width: 550px;
    padding-bottom: 61px;
    line-height: 1.5em;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (max-width: 576px) {
        width: 100%;
    }
`;
const $3b5c46f6593f9a38$var$SLink = (0, $avNx5.default).a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme: theme })=>theme.font.midDarkColor};
        cursor: pointer;
    }
`;
var $3b5c46f6593f9a38$export$ead8dc60ae5441ac;
(function(LandingMessageType) {
    LandingMessageType["SUCCESS"] = "success";
    LandingMessageType["ERROR"] = "error";
    LandingMessageType["INFO"] = "info";
})($3b5c46f6593f9a38$export$ead8dc60ae5441ac || ($3b5c46f6593f9a38$export$ead8dc60ae5441ac = {}));
var $3b5c46f6593f9a38$export$ea871832d7359f7e;
(function(LandingMessageTitle) {
    LandingMessageTitle["DEFAULT"] = "MyChargeSpace";
    LandingMessageTitle["ADMIN"] = "HaloAdmin";
})($3b5c46f6593f9a38$export$ea871832d7359f7e || ($3b5c46f6593f9a38$export$ea871832d7359f7e = {}));
const $3b5c46f6593f9a38$var$renderIcon = (type)=>{
    if (type) {
        if (type === "success") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $45iue.LandingMessageSuccessIcon), null);
        if (type === "error") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $4og9Q.LandingMessageErrorIcon), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $6Bp5U.InfoIcon), {
            size: 90,
            fill: (0, $3aX9D.theme).brandColors.CA_Green
        });
    }
};
function $3b5c46f6593f9a38$export$d88a99e06d24b3e0({ title: title, type: type, linkText: linkText, onClick: onClick, children: children, className: className, style: style, icon: icon }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3b5c46f6593f9a38$var$SWrapper, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $eQidV.FormHeader), {
        "data-testid": "header",
        className: "mb-6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3b5c46f6593f9a38$var$SIcon, null, icon || $3b5c46f6593f9a38$var$renderIcon(type)), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("h4", {
        className: "m-0 mb-3"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3b5c46f6593f9a38$var$SBody, null, children), linkText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($3b5c46f6593f9a38$var$SLink, {
        onClick: onClick,
        "data-testid": "linkBtn"
    }, linkText) : null);
}

});
parcelRegister("3skFI", function(module, exports) {
$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return (parcelRequire("45iue")).LandingMessageSuccessIcon; });
parcelRequire("45iue");

});
parcelRegister("45iue", function(module, exports) {

$parcel$export(module.exports, "LandingMessageSuccessIcon", function () { return $02e1e689e1d52e53$export$cd9c9d539c03064b; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");
function $02e1e689e1d52e53$export$cd9c9d539c03064b({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("svg", {
        width: 90,
        height: 90,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("g", {
        fill: "#81E18B"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("path", {
        d: "m30.03 52.553 7.364 7.375 30.94-30.941 1.044 1.043-31.985 31.985-8.407-8.42-2.536-2.54-5.578-5.588 1.044-1.042 5.578 5.587 2.536 2.54Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475ZM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45Z"
    })));
}

});


parcelRegister("gqF3g", function(module, exports) {
$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return (parcelRequire("4og9Q")).LandingMessageErrorIcon; });
parcelRequire("4og9Q");

});
parcelRegister("4og9Q", function(module, exports) {

$parcel$export(module.exports, "LandingMessageErrorIcon", function () { return $3faa1afd475454d4$export$651986bbbb409f50; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");
function $3faa1afd475454d4$export$651986bbbb409f50({ className: className, style: style }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 90,
        height: 90,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("g", {
        fill: "#DF0017"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("path", {
        d: "m63.596 27.08-5.902 5.9-1.844 1.845-28.77 28.77-1.044-1.043 28.77-28.77 1.845-1.844 5.901-5.902 1.044 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("path", {
        d: "M62.92 63.595 26.406 27.08l1.043-1.043 36.516 36.516-1.043 1.043z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement("path", {
        d: "M45 1.475C20.962 1.475 1.475 20.962 1.475 45S20.962 88.525 45 88.525 88.525 69.038 88.525 45 69.038 1.475 45 1.475zM0 45C0 20.147 20.147 0 45 0s45 20.147 45 45-20.147 45-45 45S0 69.853 0 45z"
    })));
}

});






parcelRegister("6jyTD", function(module, exports) {
$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return (parcelRequire("g4QXY")).ResetPasswordRequestErrorPage; });
parcelRequire("g4QXY");

});
parcelRegister("g4QXY", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordRequestErrorPage", function () { return $5dcc4e9695d9bacf$export$74ef4c4eee19ea3d; });

var $jGnJo = parcelRequire("jGnJo");

var $aRVd9 = parcelRequire("aRVd9");

var $avNx5 = parcelRequire("avNx5");

var $gCMx8 = parcelRequire("gCMx8");
parcelRequire("b2a4Y");
var $dlHVP = parcelRequire("dlHVP");

var $gCykg = parcelRequire("gCykg");

var $3aX9D = parcelRequire("3aX9D");

var $fzqPg = parcelRequire("fzqPg");

var $1IbJL = parcelRequire("1IbJL");
const $5dcc4e9695d9bacf$var$Title = (0, $avNx5.default).div`
    font-size: 24px;
    padding-bottom: 20px;
`;
function $5dcc4e9695d9bacf$export$74ef4c4eee19ea3d({ className: className, style: style }) {
    const text = (0, $1IbJL.default)();
    const navigate = (0, $gCMx8.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $gCykg.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($aRVd9)))(className),
        style: style,
        background: (0, $3aX9D.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $dlHVP.LandingMessage), {
        linkText: text("lblReturnToSignIn"),
        onClick: ()=>navigate("/login", {
                replace: true
            }),
        type: (0, $dlHVP.LandingMessageType).ERROR
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement($5dcc4e9695d9bacf$var$Title, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSomethingWentWrong"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jGnJo))).createElement((0, $fzqPg.default), {
        code: "lblSignUpError"
    })));
}

});


})();
//# sourceMappingURL=index.21840369.js.map
